import { render } from "./saveTemplateDialog.vue?vue&type=template&id=03736f47&scoped=true&lang=pug"
import script from "./saveTemplateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./saveTemplateDialog.vue?vue&type=script&setup=true&lang=js"

import "./saveTemplateDialog.vue?vue&type=style&index=0&id=03736f47&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-03736f47"

export default script